import { streamFile } from '~/common/miscUtils';
import { notifyDownloadError } from '~/common/notifyDownloadError';
import { captureTypedPosthogEvent, POSTHOG_EVENTS, type PosthogEventPropertyMap } from '~/common/posthogEvents';
import type { FileDownload } from '~/common/types';

/** Where the download started and the entity IDs known there. */
export type FileDownloadContext = Omit<
  PosthogEventPropertyMap[typeof POSTHOG_EVENTS.fileDownloaded],
  'file_name' | 'file_id' | 'file_size'
>;

/**
 * Hands a stored file to the browser through the signed URL `getDownload` resolves to, and captures
 * `file_downloaded` on hand-off; shows the generic error toast when the URL can't be had.
 */
export async function downloadAndTrackFile(
  file: { name: string; id?: string },
  context: FileDownloadContext,
  getDownload: () => Promise<FileDownload>,
): Promise<void> {
  let download: FileDownload;
  try {
    download = await streamFile(getDownload, file.name, context.source);
  } catch {
    notifyDownloadError();
    return;
  }

  captureTypedPosthogEvent(POSTHOG_EVENTS.fileDownloaded, {
    ...context,
    file_name: file.name,
    file_id: file.id,
    file_size: download.filesize,
  });
}
